import { INamespaceActionCreator, IReducer } from '@omaze/redux';

import { TOOLTIP_ACTIONS } from '../../Tooltip.actions';
import { createTooltipActionCreatorFactory, createTooltipReducerFactory } from '../../Tooltip.factories';
import { ITooltipMessage, ITooltipState } from '../../Tooltip.state';

export const createTooltipRemoveAction: INamespaceActionCreator = createTooltipActionCreatorFactory(
    TOOLTIP_ACTIONS.REMOVE,
    (): ITooltipMessage => {
        return {
            messageComponent: null,
            ref: null,
        };
    },
);

export const createTooltipRemoveReducer: IReducer<ITooltipState> = createTooltipReducerFactory(
    TOOLTIP_ACTIONS.REMOVE,
    (state: ITooltipState): void => {
        state.message = null;
    },
);
